import { render, staticRenderFns } from "./PageIndex.vue?vue&type=template&id=ee90f786&scoped=true"
import script from "./PageIndex.vue?vue&type=script&lang=js"
export * from "./PageIndex.vue?vue&type=script&lang=js"
import style0 from "./PageIndex.vue?vue&type=style&index=0&id=ee90f786&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee90f786",
  null
  
)

export default component.exports